import { render, staticRenderFns } from "./ButtonLanguage.vue?vue&type=template&id=6e90f5da&lang=pug&"
import script from "./ButtonLanguage.vue?vue&type=script&lang=js&"
export * from "./ButtonLanguage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/danielrubiocastillo/Documents/workspaces/emaraplay/lobby-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e90f5da')) {
      api.createRecord('6e90f5da', component.options)
    } else {
      api.reload('6e90f5da', component.options)
    }
    module.hot.accept("./ButtonLanguage.vue?vue&type=template&id=6e90f5da&lang=pug&", function () {
      api.rerender('6e90f5da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ButtonLanguage.vue"
export default component.exports